export default function CatalogStats({ stats }) {
  const items = [
    [stats.robotCount, "robots"],
    [stats.manufacturerCount, "manufacturers"],
    [stats.countryCount, "countries"],
    [stats.publicPriceCount, "with public prices"],
  ];
  return (
    <dl className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {items.map(([value, label]) => (
        <div key={label} className="rounded-2xl border border-white/15 bg-white/10 p-4 backdrop-blur">
          <dt className="text-xs font-bold uppercase tracking-[0.16em] text-blue-100">{label}</dt>
          <dd className="mt-2 text-3xl font-black text-white">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
